import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Provider } from "react-redux";
import { makeStore } from "~/store";
export const PublicAssetReduxProvider = /*#__PURE__*/ memo((param)=>{
    let { children, initialClip } = param;
    const { store } = useMemo(()=>{
        const { store } = makeStore({
            centralizedClip: {
                clip: {
                    ...initialClip,
                    boards: []
                },
                loading: false
            }
        });
        return {
            store
        };
    }, [
        initialClip
    ]);
    return /*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: children
    });
});
PublicAssetReduxProvider.displayName = "PublicAssetReduxProvider";
